<form [formGroup]="selectSafeharborsForm" (ngSubmit)="navigateToStep2()">
  <div class="row">
    <div class="col-sm-12">
      <div class="container-white">
        <div class="ui-progress-status-bar">
          <ol>
            <li class="current">
              <span class="stepnum">1</span>
              Select
            </li>
            <li class="">
              <span class="stepnum">2</span>
              Review
            </li>
          </ol>
        </div>
        <div style="margin-top: 20px;margin-bottom: 20px;">
            <h4>Safe Harbor Plans</h4>
        </div>

        <div class="row">
          <div class="col-sm-6" align="left">                
            <p class="input-group">
              <label style="margin-right: 5px;">Effective Date</label>
              <span *ngIf="submitted && f.shEffectiveDate.errors" class="message-error">
                <span *ngIf="f.shEffectiveDate.errors.required">
                  <span>Effective Date is required</span>
                </span>
              </span>

              <span *ngIf="showNotValidEffectiveDate" class="message-error">
                  <span>Not a valid effective date</span>                
              </span>
            </p>
          </div>

          <div class="col-sm-6" align="left">
            <p class="input-group">
              <label style="margin-left: 15px;margin-right: 5px;">Release Date</label>
              <span *ngIf="submitted && f.shRelDate.errors" class="message-error">
                <span *ngIf="f.shRelDate.errors.required">Release Date is required</span>
              </span>

              <span *ngIf="showNotValidReleaseDate" class="message-error">
                <span>Not a valid release date</span>                
            </span>
           </p>
          </div>
          </div>
          <div class="row" style="margin-top: -100px !important;">
            <div class="col-sm-6" align="left">
              <p-datepicker 
                formControlName="shEffectiveDate" 
                [(ngModel)]="effectiveDate" 
                [ngClass]="{ 'is-invalid': submitted && f.shEffectiveDate.errors }"
                [showOnFocus]="false"
                (keydown)="onlyNumbers($event)"
                (keyup)="addSlash($event)"
                (onInput)='updateValueOnInput($event, "EffectiveDate")'
                (onSelect)='updateValueOnSelect($event, "EffectiveDate")'
                placeholder="MM/DD/YYYY" 
                [minDate]="maxDate" [icon]="'arrow'"
                [required]="true" #calendarEffDate>
              </p-datepicker>
              <span class="input-group-btn beneficiary-calendar" style="display:inline">
                <a (click)="calendarEffDate.toggle()"><i class="icon-utility-calendar"></i></a>
            </span>
            </div>

            <div class="col-sm-6" align="left">
              <label style="margin-left: 15px;"></label>
              <p-datepicker  
                formControlName="shRelDate" 
                [(ngModel)]="releaseDate"
                [ngClass]="{ 'is-invalid': submitted && f.shRelDate.errors }"
                [showOnFocus]="false"
                (keydown)="onlyNumbers($event)"
                (keyup)="addSlash($event)"
                (onInput)='updateValueOnInput($event, "ReleaseDate")'
                (onSelect)='updateValueOnSelect($event, "ReleaseDate")'
                placeholder="MM/DD/YYYY" [minDate]="maxDate" [icon]="'arrow'" 
                [required]="true" #calendarRelDate>
              </p-datepicker>
              <span class="input-group-btn beneficiary-calendar" style="display:inline">
                  <a (click)="calendarRelDate.toggle()"><i class="icon-utility-calendar"></i></a>
              </span>
            </div>
          </div>

          <div id="subgroupPicklist">
            <p-pickList              
              [source]="filteredAvailableSubgroupsList"   
              [target]="selectedSubgroupsList"
              [target]="selectedSubgroupsList"
              dragdrop="true"
              dragdropScope=""
              [responsive]="true"
              [sourceStyle]="{'height':'300px', 'width':'420px'}"
              [targetStyle]="{'height':'300px', 'width':'420px'}"
              ui-picklist-buttons
              [showSourceControls]="false"
              [showTargetControls]="false"
              (onMoveToTarget)="outPutSelections()"
              (onMoveToSource)="outPutRemovals()"  
            >
              <ng-template pTemplate="sourceHeader" class="p-0">
                <div>
                  Available Subgroups ({{ filteredAvailableSubgroupsList.length }})
                </div>
              </ng-template>
              <ng-template pTemplate="targetHeader">
                <div>
                  Selected Subgroups ({{selectedSubgroupsList.length}})
                </div>
              </ng-template>

              <ng-template let-availableSubgroupsList #availableSubgroupsList pTemplate="item">
                <div class="picklist-item">
                  {{availableSubgroupsList}}
                </div>
              </ng-template>
            </p-pickList>
          </div>

          <div class="message-error" *ngIf="!selectedSubGrpListCnt" align="center" style="margin-top: 15px;">
            <span>Safe harbor plan(s) must be selected in order to continue with the transaction.</span>
          </div>

      </div>

      <div style="margin-top: 20px;">
        <button class="btn btn-primary">Next</button>
      </div>
    </div>
  </div>
</form>